define('presentation/settings/integrations/facades/addIntegrationFacade',[
    'externalDependencies/clientWebSocket',
    'persistence/webSocket/webSocketApp'
], function() {

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const integrationSocket = clientWebSocket.forApplication("integrations");

    let _promiseFactory = null;

    const _addIntegrationAccessToken = (platform, authorizationCode, redirectUri) => {
        return _promiseFactory.defer((promise) => {
            const parameters = {
                platform: platform,
                authorizationCode: authorizationCode,
                redirectUri: redirectUri
            };

            integrationSocket.send("connect", parameters, (response) => {
                if (response.isSuccessful === false) {
                    promise.reject();
                    return;
                }
                promise.resolve(response);
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function() {
        const self = this;

        self.init = _init;
        self.addIntegrationAccessToken = _addIntegrationAccessToken;
    };
});

